<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ii"></a>
<p class="dedit"><em class="italic">To</em></p>
<p class="dedi">Oberst Birger Kristian Eriksen</p>
<p class="dedi">and the others who fought and died</p>
<p class="dedi">in the battle for Norway in 1940.</p>
<div class="img_containert" id="pgiiimg1">
<img alt="images" src="images/f00ii-01.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedication.vue?bca1c994